<template>
  <div class="self-tenant-edit">
    <h1>{{ $t('settings.editTenant') }}</h1>

    <div v-if="loading" class="loading-container">
      <el-skeleton :rows="10" animated />
    </div>

    <tenant-form
      v-else
      :tenant="tenant"
      mode="edit"
      @submit="onSubmit"
      :loading="submitLoading">
    </tenant-form>
  </div>
</template>

<script>
import {tenantService} from '@/services/TenantService.class';
import TenantForm from '@/components/tenants/TenantForm';

export default {
  name: "SelfTenantEdit",
  components: {TenantForm},
  data() {
    return {
      tenant: null,
      loading: true,
      submitLoading: false,
      error: ''
    }
  },
  mounted() {
    this.loadTenant();
  },
  methods: {
    loadTenant() {
      this.loading = true;
      tenantService.getSelf()
        .then(response => {
          this.tenant = response.data;
        })
        .catch(error => {
          console.error('Error loading tenant:', error);
          this.$message.error(this.$t('settings.genericHttpError'));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSubmit(tenant) {
      this.submitLoading = true;
      tenantService.patchSelf(tenant)
        .then(() => {
          this.$message.success(this.$t('settings.patchSuccess'));

          // Update tenant in store
          this.$store.commit('tenant/setSelectedTenant', tenant);

          // Reload tenant data
          this.loadTenant();
        })
        .catch(error => {
          console.error('Error updating tenant:', error);
          this.$message.error(this.$t('settings.genericHttpError'));
        })
        .finally(() => {
          this.submitLoading = false;
        });
    }
  }
}
</script>

<style scoped lang="scss">
.self-tenant-edit {
  padding: 0 15px;

  h1 {
    margin-bottom: 30px;
    font-weight: 500;
    color: #303133;
  }

  .loading-container {
    padding: 20px;
  }
}
</style>
